import { Flex, IconButton, Text } from "@chakra-ui/react";
import { MdRefresh } from "react-icons/md";

export default function FolderHeader({
  OnRefetch = () => {},
  OnSelect = () => {},
  Lang,
  texts = {} 
}) {
  const fileManagerTexts = texts?.fileManager || {};

  return (
    <Flex
      fontWeight="bold"
      justify={"space-between"}
      fontSize={{ base: "0.9em", md: "0.9rem" }}
      h={"2rem"}
      px={2}
    >
      <Flex alignItems={"center"}>
        <Text as={"span"} onClick={() => OnSelect(null)} cursor={"pointer"}>
          {Lang?.Folder?.TITLE || fileManagerTexts.folders || "Folders"}
        </Text>
      </Flex>
      <Flex alignItems={"center"} gap={1}>
        <IconButton
          icon={<MdRefresh />}
          aria-label={fileManagerTexts.ariaLabels?.refreshConversation || "Refresh Conversation"}
          size="xs"
          fontSize={"1rem"}
          className="Btn"
          onClick={() => OnRefetch()}
        />
 
      </Flex>
    </Flex>
  );
}